<template>
  <card class="card--publication"
    :horizontal="horizontal"
    :card-color="cardColor"
    :text-color="textColor"
    :accent-color="accentColor"
    :border-color="borderColor">
    <template v-slot:media v-if="toBase(publication.image || placeholderImage)">
      <img
        class="card--publication__image"
        :src="toBase(publication.image || placeholderImage)"
        :alt="'Image ' + publication.title" />
    </template>
    <template v-slot:header>
      <h6 class="card--publication__title">{{ publication.title }}</h6>
    </template>
    <template v-slot:body>
      <p class="card--publication__authors">
        {{ authorNames(publication.authors) }}
      </p>
      <p class="card--publication__conference">
        {{ publication.journal }} {{ publication.date.year ? ' (' + publication.date.year + ')' : '' }}
      </p>
    </template>
    <template v-slot:actions>
      <div class="card--publication__external-ids">
        <a
          v-if="publication.externalIds.doi"
          :href="'https://doi.org/' + publication.externalIds.doi"
          target="_blank"
          title="Search by DOI">
          <img :src="toBase('/static/img/doi.svg')" width="32px" />
        </a>
        <a
          v-if="publication.externalIds.otherid"
          :href="'https://dblp.org/rec/html/' + publication.externalIds.otherid.substr(5)"
          target="_blank"
          title="Open Publication on DBLP">
          <img :src="toBase('/static/img/dblp-icon.png')" width="32px" />
        </a>
        <a
          v-if="publication.externalIds.authenticus"
          :href="'https://authenticus.pt/' + publication.externalIds.authenticus"
          target="_blank"
          title="Open Publication on Authenticus">
          <img :src="toBase('/static/img/authenticus.png')" width="32px" />
        </a>
        <!-- <a
          v-if="publication.externalIds.eid"
          :href="'https://scopus.com/' + publication.externalIds.eid"
          target="_blank"
          title="Open Publication on Scopus">
          <img :src="toBase('/static/img/scopus.png')" width="32px" />
        </a> -->
      </div>
    </template>
  </card>
</template>

<script>
import { mapGetters } from 'vuex'

import { authorNames } from '@/utils/utils.js'

import Card from '@/components/Card'

export default {

  name: 'publication-card',

  props: {
    horizontal: {
      type: Boolean,
      default: false
    },
    cardColor: {
      type: String,
      default: '#ffffff'
    },
    textColor: {
      type: String,
      default: '#ffffff'
    },
    accentColor: {
      type: String,
      default: '#ffffff'
    },
    borderColor: {
      type: String,
      default: '#ffffff'
    },
    publication: {
      type: Object,
      default: () => ({
        'id': 'ID of the publication',
        'title': 'Publication Title',
        'journal': 'Journal of the publication',
        'description': 'Abstract of the publication',
        'type': 'Type of publication',
        'authors': [
          'John Doe'
        ],
        'date': {
          'year': 2000
        },
        'externalIds': {}
      })
    },
    placeholderImage: {
      type: String
    }
  },

  components: {
    'card': Card
  },

  computed: {
    ...mapGetters(['toBase'])
  },

  methods: {
    authorNames
  }
}
</script>

<style lang="scss" scoped>
.card--publication {

  &__title {
    font-size: 1.3rem;
    color: var(--text-color);
  }

  &__authors {
    font-size: 1rem;
    font-style: italic;
    line-height: 1.6rem;
    overflow: hidden;
  }

  &__conference {
    font-size: 1rem;
    line-height: 1.6rem;
    overflow: hidden;
    margin-top: 0.5rem;
    font-weight: 300;
  }

  &__external-ids {
    display: flex;
    justify-content: flex-end;
    flex: 1;

    a {
      margin-right: 0.5rem;

      &:last-child {
        margin-right: 0.0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PublicationCard.vue